// styles
import {
    CardCountPillContainer
} from './CardCountPill.styles.js';

// assets
import cardIcon from '../../assets/system/icons/card-icon.png';

export default function CardCountPill({ value }) {
    return (
        <CardCountPillContainer>
            <h5>{value}</h5>
            <img src={cardIcon} alt="card icon" />
        </CardCountPillContainer>
    )
}

